export default class Accordion {
    constructor(el) {
        // let tabs = document.querySelector(".c-accordion__tabs");

        // get height of tab & tab content when open
        el.querySelectorAll("summary").forEach((detail) => {
            var tabStyle = window.getComputedStyle(detail.parentElement);
            var tabMargin = parseFloat(tabStyle['marginBottom']);
            var contentStyle = window.getComputedStyle(detail.parentElement.children[1]);
            var contentHeight = parseFloat(contentStyle['height']) + parseFloat(contentStyle['marginBottom']) + tabMargin;
            var tabHeight = detail.offsetHeight;

            detail.parentElement.style.setProperty('--tab-height', `${tabHeight}px`);
            detail.parentElement.style.setProperty('--content-height', `${tabHeight + contentHeight}px`);
        });
        
        el.addEventListener("click", (event) => {
            if (event.target.tagName !== "SUMMARY") return;

            let targetDetails = event.target.parentElement;

            // Close other <details> elements before the target opens
            el.querySelectorAll("summary[open]").forEach((detail) => {
                if (detail !== targetDetails) {
                    detail.removeAttribute("open");
                    detail.querySelector("summary").setAttribute("aria-expanded", "false");
                }
            });

            // Toggle aria-expanded for the clicked tab
            if (event.target.getAttribute("aria-expanded") === "true") {
                event.target.setAttribute("aria-expanded", "false");
            } else if (event.target.getAttribute("aria-expanded") === "false") {
                event.target.setAttribute("aria-expanded", "true");
            }
        });

        // Keyboard accessibility for el
        el.addEventListener("keydown", (event) => {
            if (event.key === "Enter" && event.target.tagName === "SUMMARY") {
                event.target.click();
            }
        });
    }
}
